import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BrokerRegistrationConfirmationTypeModel } from 'src/app/models/broker-registration/broker-registration-confirmation-type.model';
import { BrokerRegistrationService } from 'src/app/services/brokers/broker-registration.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-broker-registration-confirmation',
  standalone: false,
  templateUrl: './broker-registration-confirmation.component.html',
  styleUrl: './broker-registration-confirmation.component.scss',
})
export class BrokerRegistrationConfirmationComponent {
  confirmationType?: BrokerRegistrationConfirmationTypeModel;
  isLoading = true;
  hasError = false;
  
  BrokerRegistrationConfirmationType = 
    BrokerRegistrationConfirmationTypeModel;

  constructor(
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private registrationService: BrokerRegistrationService,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParams['token'];

    if (!token) {
      this.isLoading = false;
      this.hasError = true;
      return;
    }

    this.confirm(token);
  }

  private confirm(token: string): void {
    this.loadingService
      .load(this.registrationService.confirm(token))
      .subscribe({
        next: (result) => {
          this.confirmationType = result.type;
          this.isLoading = false;
        },
        error: () => {
          this.hasError = true;
          this.isLoading = false;
        }
      });
  }
}
